import MaterialTable from 'material-table'
import { ThemeProvider } from '@mui/styles'
import { createTheme } from '@mui/material';

import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumnOutlined';

import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ArrowDownward from '@material-ui/icons/ArrowDownward';


import * as XLSX from 'xlsx'
import React, { forwardRef, useEffect, useState, useContext } from 'react'
import './dataTableCustomers.scss'
import { DataGrid } from '@mui/x-data-grid';
import { userColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where, getDoc } from "firebase/firestore";
import { db } from '../../firebase'
import ConfirmBox from '../ConfirmBox';
import { AuthContext } from '../../context/AuthContext'

const DataTable = () => {

    const [ data, setData ] = useState([])

    const [ allData, setAllData] = useState([])

  
  const [ isLoading, setIsLoading ] = useState(true)

  const [open, setOpen] = useState(false);

  const [deleteId, setDelete] = useState("");

  const { currentUser } = useContext(AuthContext)
    
  const userId = currentUser.uid;
  
  const [adminRole, setAdminRole] = useState("")
  
  const getAdminRole = async() => {
    
          const docRef = doc(db, "admins", userId);
    
          const docSnap = await getDoc(docRef);
    
          
          if (docSnap.exists()) {
    
            setAdminRole(docSnap.data().role)

          } else {

            console.log("No such document!");
          }
  }

  useEffect(()=>  {

    getAdminRole()

  }, [])


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

 useEffect(() => {

// //LISTEN REAL TIME

    const collectionRef = collection(db, "users")
    const queryCustomers = query(collectionRef, orderBy("timeStamp", "desc"))

    const unsub = onSnapshot(queryCustomers, (snapShot) => {
      let list = [];
      let all = [];
      snapShot.docs.forEach((doc) => {
        list.push({ id: doc.id, customerID: doc.data().customerID, firstname: doc.data().firstname, lastname: doc.data().lastname, image: doc.data().userImage, email: doc.data().email, phoneNumber: doc.data().phoneNumber, agentCode : doc.data().agentCode, date: doc.data().timeStamp.toDate().toLocaleDateString(), status: doc.data().status, referalCode: doc.data().referalCode});
        // allData.push({ id: doc.id, ...doc.data() })
      })
      setData(list)
      // setAllData(all)
      setIsLoading(false)
    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

  },[])


    function openDelete(id) {
      setOpen(true);
      setDelete(id);
    }
  
    console.log(data)
  
    const handleDelete = async() => {
  
      await deleteDoc(doc(db, "users", deleteId));
        
        setData(data.filter((item) => item.id !== deleteId))
  
        setOpen(false)
  
    }


    const tableIcons = {
      Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
      Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
      Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
      Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
      DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
      Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
      Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
      Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
      FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
      LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
      NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
      PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
      ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
      Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
      SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
      ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
      ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };


    const theme = createTheme({
      status: {
        danger: 'red',
      },
    });

    const downloadExcel=()=>{
      const newData=data.map(row=>{
        delete row.tableData
        return row
      })
      const workSheet=XLSX.utils.json_to_sheet(newData)
      const workBook=XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook,workSheet,"customers")
      //Buffer
      let buf=XLSX.write(workBook,{bookType:"xlsx",type:"buffer"})
      //Binary string
      XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
      //Download
      XLSX.writeFile(workBook,"CustomersData.xlsx")


    }
  return (
    <>
    <div style={{}}>
      {/* <h1 align="center">React-App</h1>
      <h4 align='center'>Export Data to Excel in Material Table</h4> */}

      {
        isLoading
        ?
        <Spinner/>
        :

        adminRole === "adminAccess"

        ?

        <ThemeProvider theme={theme}>

          <MaterialTable
          icons={tableIcons}
          title="All Customers"
          columns={userColumns}
          data={data}

          // actions={[
          //   rowData => ({
          //   icon: tableIcons.ViewColumn,
          //   position: "row",
          //   tooltip: "View User",
          //   onClick: (event, rowData) => alert("You saved " + rowData.name)
          // }),
          
          // {icon:()=><button>Export</button>,// you can pass icon too
          //   tooltip:"Export to Excel",
          //   onClick:()=>downloadExcel(),
          //   isFreeAction:true
          //   },
                
      
          // {
          //   icon: tableIcons.Delete,
          //   tooltip: 'Delete Student',
          //   // onClick: (event, rowData) => alert("You want to delete " + rowData.name),
          //   // disabled: rowData.birthYear < 2000
          // },
        
          // ]}

        actions={[
          // not working

          {
            action: rowData => ({
              icon: tableIcons.ViewColumn,
              tooltip: "View User",
              onClick: (event, rowData) => window.location.href=`/customers/${rowData.id}` 
            }),
            position: "row"
          },

          {
            action: rowData => ({
              icon: tableIcons.Delete,
              tooltip: "Delete User",
              onClick: (event, rowData) => openDelete(rowData.id)
            }),
            position: "row"
          },
            {icon:()=><button>Export</button>,// you can pass icon too
            tooltip:"Export to Excel",
            onClick:()=>downloadExcel(),
            isFreeAction:true
            },
        ]}


          options={{
            exportButton: true,
            // exportAllData: true, 
            // exportFileName: 'MyExportedData', 
            // exportColumns: ['customerID', 'firstname', 'lastname', 'email', 'phoneNumber', 'firstname', 'firstname'],
            sorting: true,
            selection: true,
            pageSize: 20,
            actionsColumnIndex: -1,
            exportCsv: (columns, data) => {
              downloadExcel()
            },

            headerStyle: {
              // backgroundColor: '#01579b',
              fontWeight: 'bold',
              fontSize: 16
            }
          }}

        />
        </ThemeProvider>

        :

        adminRole === "subadminAccess"

        ?

        <ThemeProvider theme={theme}>

          <MaterialTable
          icons={tableIcons}
          title="All Customers"
          columns={userColumns}
          data={data}

        actions={[
          // not working

          {
            action: rowData => ({
              icon: tableIcons.ViewColumn,
              tooltip: "View User",
              onClick: (event, rowData) => window.location.href=`/customers/${rowData.id}` 
            }),
            position: "row"
          },

          {
            action: rowData => ({
              icon: tableIcons.Delete,
              tooltip: "Delete User",
              onClick: (event, rowData) => openDelete(rowData.id)
            }),
            position: "row"
          },
            {icon:()=><button>Export</button>,// you can pass icon too
            tooltip:"Export to Excel",
            onClick:()=>downloadExcel(),
            isFreeAction:true
            },
        ]}


          options={{
            exportButton: true,
            // exportColumns: ['customerID', 'firstname', 'lastname', 'email', 'phoneNumber', 'firstname', 'firstname'],
            sorting: true,
            selection: true,
            pageSize: 20,
            actionsColumnIndex: -1,
            exportCsv: (columns, data) => {
              downloadExcel()
            },

            headerStyle: {
              // backgroundColor: '#01579b',
              fontWeight: 'bold',
              fontSize: 16
            }
          }}

        />
        </ThemeProvider>

        :

          <ThemeProvider theme={theme}>

          <MaterialTable
          icons={tableIcons}
          title="All Customers"
          columns={userColumns}
          data={data}


        actions={[
          // not working

          {
            action: rowData => ({
              icon: tableIcons.ViewColumn,
              tooltip: "View User",
              onClick: (event, rowData) => window.location.href=`/customers/${rowData.id}` 
            }),
            position: "row"
          },
          
            {icon:()=><button>Export</button>,// you can pass icon too
            tooltip:"Export to Excel",
            onClick:()=>downloadExcel(),
            isFreeAction:true
            },
        ]}


          options={{
            exportButton: true,  
            // exportColumns: ['customerID', 'firstname', 'lastname', 'email', 'phoneNumber', 'firstname', 'firstname'],
            sorting: true,
            selection: true,
            pageSize: 20,
            actionsColumnIndex: -1,
            exportCsv: (columns, data) => {
              downloadExcel()
            },

            headerStyle: {
              // backgroundColor: '#01579b',
              fontWeight: 'bold',
              fontSize: 16
            }
          }}

        />
        </ThemeProvider>



        

      }

    
    </div>

     <ConfirmBox
      open={open}
      closeDialog={() => setOpen(false)}
      // title={deleteData?.name}
      deleteFunction={handleDelete}
    />
    </>
  );
}

export default DataTable;


